import { render, staticRenderFns } from "./VSelectR.vue?vue&type=template&id=a6afe272&scoped=true&lang=pug&"
import script from "./VSelectR.vue?vue&type=script&lang=js&"
export * from "./VSelectR.vue?vue&type=script&lang=js&"
import style0 from "./VSelectR.vue?vue&type=style&index=0&id=a6afe272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6afe272",
  null
  
)

export default component.exports